import {AppState} from "../store/AppState";
import {License} from "../../model/entitlement/License";

function selectLicenses(state: AppState): License[]|undefined {
  const { licenses } = state;
  return licenses ? Object.keys(licenses).map((lid) => licenses[lid]) : undefined;
}
function compareLicensesStates(next: AppState, prev: AppState) {
  return next.licenses === prev.licenses;
}
const LicensesUtils = {
  selectLicenses,
  compareLicensesStates,
}
export default LicensesUtils;
